import React from 'react'
import { Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useGetRetentionPolicyQuery } from '../../../store/account/account'
import { RetentionPolicySessionResourceBody } from './RetentionPolicySessionResourceBody'
import { RetentionPolicyRoomResourceBody } from './RetentionPolicyRoomResourceBody'
import { RetentionPolicyFileResourceBody } from './RetentionPolicyFileResourceBody'
import { RetentionPolicyEventRuleBody } from './RetentionPolicyEventRuleBody'
import { RetentionPolicyTTLRuleBody } from './RetentionPolicyTTLRuleBody'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { Button } from '../../../components/Button/Button'
import { Modal } from '../../../components/Modal/Modal'
import { RetentionPolicyRuleType } from './RetentionPolicyRuleType'
import { RetentionPolicyResourceType } from './RetentionPolicyResourceType'

export interface ViewPolicyModalProps {
  policyId: string
  show: boolean
  onHide: () => void
}

export const ViewPolicyModal: React.FC<ViewPolicyModalProps> = ({ policyId, show, onHide }) => {
  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>View Data Retention Policy</h4>
        </Col>
      </Row>
      <Row>
        <ViewPolicyModalForm policyId={policyId} show={show} onHide={onHide} />
      </Row>
    </Container>
  )

  const footer = (
    <div>
      <Button variant='secondary' onClick={onHide}>
        Cancel
      </Button>{' '}
    </div>
  )

  return <Modal show={show} onHide={onHide} header={<></>} body={body} footer={footer} centered={true} />
}

const ViewPolicyModalForm: React.FC<ViewPolicyModalProps> = ({ policyId }) => {
  const accountId = useAppSelector(selectAccountId)

  const { data, error, isFetching } = useGetRetentionPolicyQuery({ accountId: accountId, policyId: policyId }, { refetchOnMountOrArgChange: true })

  const ruleBodyMap = {
    ttl: RetentionPolicyTTLRuleBody,
    event: RetentionPolicyEventRuleBody,
  }

  const resourceBodyMap = {
    file: RetentionPolicyFileResourceBody,
    room: RetentionPolicyRoomResourceBody,
    session: RetentionPolicySessionResourceBody,
  }

  return (
    <Container className='d-flex flex-column gap-4 p-0'>
      {isFetching ? (
        <div className='d-flex align-items-center justify-content-center'>
          <Spinner />
        </div>
      ) : (
        <>
          {data?.data ? (
            <>
              <Row>
                <Col>
                  <>
                    <div>Rule Type</div>
                    <div>
                      <RetentionPolicyRuleType type={data.data.rule.type} />
                    </div>
                  </>
                </Col>
              </Row>
              {React.createElement(ruleBodyMap[data.data.rule.type], { retentionRule: data.data.rule })}
              <Row>
                <Col>
                  <div>Resource Type</div>
                  <RetentionPolicyResourceType type={data.data.resource.type} />
                </Col>
              </Row>
              {React.createElement(resourceBodyMap[data.data.resource.type], { retentionResource: data.data.resource })}
            </>
          ) : (
            'Something went wrong'
          )}
        </>
      )}
    </Container>
  )
}
